export function paymentInstallments(value: number | string) {
  const valueConvert = typeof value === 'string' ? Number(value) : value

  const minimumValue = 8.25
  const installmentValue = {
    quantity: 1,
    value: valueConvert,
  }

  for (let i = 12; i >= 1; i--) {
    if (valueConvert / i >= minimumValue) {
      installmentValue.quantity = i
      installmentValue.value = valueConvert / i
      break
    }
  }

  return installmentValue
}
